import App from './App';
void new App().start();